import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { Switch, withRouter } from "react-router";
import { Navigationbar, PrivateRoute } from "src/components/";
import { observer } from "mobx-react";
import { getParams, getRoute, Route } from "src/config/routes";
import * as Screens from "src/screens";
import { NAVIGATIONBAR_TYPE } from "src/components/header/navigationbar/Navigationbar";
import "./Assembly.css";
import { RootStoreContext } from "src/stores/RootStore";

export const AssemblyBase = () => {
    const { authStore, assemblyStore } = useContext(RootStoreContext);

    const role = authStore.user?.role;
    const currentPage = role ? getRoute(window.location.pathname, role) : undefined;

    let params: { [key: string]: string } = {};

    if (currentPage === Route.assemblyDetails) {
        params = getParams(Route.assemblyDetails, role);
    } else if (currentPage === Route.assemblyAttendanceList) {
        params = getParams(Route.assemblyAttendanceList, role);
    } else if (currentPage === Route.assemblyProtocol) {
        params = getParams(Route.assemblyProtocol, role);
    } else if (currentPage === Route.agendaPreview) {
        params = getParams(Route.agendaPreview, role);
    } else if (currentPage === Route.assemblyCommunication) {
        params = getParams(Route.assemblyCommunication, role);
    } else if (currentPage === Route.assemblyLiveMode) {
        params = getParams(Route.assemblyLiveMode, role);
    }

    const assemblyId = params.hasOwnProperty("assemblyid") ? params["assemblyid"] : assemblyStore.NEW_ASSEMBLY_ID;

    return (
        <React.Fragment>
            {currentPage !== Route.assemblyLiveMode ? (
                <Navigationbar navigationbarType={NAVIGATIONBAR_TYPE.ASSEMBLY} assemblyId={assemblyId} />
            ) : undefined}

            <Switch>
                <PrivateRoute
                    key={Route.manager + Route.assemblyDetails}
                    path={Route.manager + Route.assemblyDetails}
                    exact
                    component={Screens.AssemblyDetails}
                />
                <PrivateRoute
                    key={Route.manager + Route.assemblyAttendanceList}
                    path={Route.manager + Route.assemblyAttendanceList}
                    exact
                    component={Screens.Attendance}
                />
                <PrivateRoute
                    key={Route.manager + Route.assemblyProtocol}
                    path={Route.manager + Route.assemblyProtocol}
                    exact
                    component={Screens.Protocol}
                />
                <PrivateRoute
                    key={Route.manager + Route.agendaPreview}
                    path={Route.manager + Route.agendaPreview}
                    exact
                    component={Screens.AgendaItemMain}
                />
                <PrivateRoute
                    key={Route.manager + Route.agendaOverview}
                    path={Route.manager + Route.agendaOverview}
                    exact
                    component={Screens.AgendaItemOverview}
                />
                <PrivateRoute
                    key={Route.manager + Route.assemblyCommunication}
                    path={Route.manager + Route.assemblyCommunication}
                    exact
                    component={Screens.Communication}
                />
                <PrivateRoute
                    key={Route.manager + Route.assemblyLiveMode}
                    path={Route.manager + Route.assemblyLiveMode}
                    exact
                    component={Screens.LiveMode}
                />
                <PrivateRoute component={Screens.ErrorNotFound} />
            </Switch>
        </React.Fragment>
    );
};

export const Assembly = Sentry.withProfiler(withRouter(observer(AssemblyBase)));
